import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const getDefaultRedirectPath = user => {
  if (user?.profile === "superadmin") {
    return "/companies";
  }

  return "/";
};

const Route = ({ component: Component, isPrivate = false, roles, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);
  const defaultRedirectPath = getDefaultRedirectPath(user);

  if (!isAuth && isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
      </>
    );
  }

  if (isAuth && !isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect
          to={{ pathname: defaultRedirectPath, state: { from: rest.location } }}
        />
      </>
    );
  }

  if (isPrivate && roles && user?.profile && !roles.includes(user.profile)) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect
          to={{ pathname: defaultRedirectPath, state: { from: rest.location } }}
        />
      </>
    );
  }

  return (
    <>
      {loading && <BackdropLoading />}
      <RouterRoute {...rest} component={Component} />
    </>
  );
};

export default Route;
